const API_BASE = (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/$/, '');

/** Résout une URL média relative (/uploads/…) en URL absolue côté client. */
export function resolveMediaUrl(url?: string | null): string | null {
  if (url == null || url === '') return null;
  const trimmed = url.trim();
  if (!trimmed) return null;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  if (trimmed.startsWith('/')) {
    return API_BASE ? `${API_BASE}${trimmed}` : trimmed;
  }
  return API_BASE ? `${API_BASE}/${trimmed}` : `/${trimmed}`;
}
